<template>
  <article class="related-news-item related-news-item--inherit-direction">
    <div
      class="related-news-item__item__content"
      :class="[{ 'related-news-item__item__content--vacancies': isVacancies }]"
    >
      <h2 :class="[{ 'related-news-item__item__content--job-title': city }]">{{ title }}</h2>
      <h3 class="related-news-item__item__content--job-title" v-if="city">/ {{ city }}</h3>
      <p v-if="description" v-html="description"></p>
      <a :href="link" v-if="linkExternal" target="_blank">
        <button type="click" class="related-news-item__item__content__btn">
          {{ buttonText }}
        </button>
      </a>

      <a :href="link" v-if="!linkExternal">
        <button type="click" class="related-news-item__item__content__btn">
          {{ buttonText }}
        </button>
      </a>
    </div>
  </article>
</template>

<script>
export default {
  name: "related-news-item",
  props: {
    title: {
      type: String,
      default: "",
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
    },
    city: {
      type: String,
    },
    linkExternal: {
      type: Boolean,
      default: false,
    },
    isVacancies: {
      type: Boolean,
      default: false,
    },
  },

  methods: {},
};
</script>

<style lang="scss">
.related-news-item {
  min-height: 350px;
  height: auto;
  display: flex;
  flex-flow: column;
  position: relative;
  width: 100%;
  transition: all 0.2s ease-out;
  max-height: 575px;

  &--inherit-direction {
    flex-flow: inherit;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
  }

  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 40px;
    outline: none;

    &__content {
      h2 {
        position: relative;
        font-size: 45px;
        font-weight: 300;
        margin-bottom: 15px;
        font-family: $hwcigars;
        font-weight: 300;
        max-width: 245px;

        &.related-news-item__item__content--job-title {
          font-size: 24px;
          max-width: none;
          margin: 0;
        }
      }

      h3 {
        position: relative;
        font-size: 45px;
        font-weight: 300;
        margin-bottom: 15px;
        font-family: $hwcigars;
        font-weight: 300;

        &.related-news-item__item__content--job-title {
          font-size: 24px;
          max-width: none;
          margin-top: 5px;
          margin-bottom: 35px;
        }
      }

      p {
        font-size: 20px;
        font-weight: 300;
        font-family: $hwcigars;
        max-width: 400px;
      }

      &__btn {
        background: transparent;
        border: 0px;
        font-size: 20px;
        margin-top: 30px;
        font-family: $hwcigars;
        font-weight: 300;
        text-decoration: none;
        cursor: pointer;
        transition: all 0.2s ease-in-out;

        &:hover {
          border-bottom: 1px solid black;
          transition: all 0.2s ease-in-out;
        }
      }

      &--vacancies {
        h2 {
          font-size: 30px;
        }

        p {
          font-size: 17px;
        }
      }
    }
  }
}

@media (max-width: 1400px) {
  .related-news-item {
    &__item {
      &__content {
        p {
          max-width: 300px;
          font-size: 18px;
        }
      }
    }
  }
}

@media (max-width: 1250px) {
  .related-news-item {
    &__item {
      h2 {
        font-size: 24px;
      }

      p {
        font-size: 21px;
        line-height: 27px;
      }

      button {
        font-size: 21px;
      }
    }
  }
}

@media (max-width: 1100px) {
  .related-news-item {
    &__item {
      p {
        font-size: 18px;
        line-height: 20px;
      }

      button {
        font-size: 20px;
      }
    }
  }
}

@media (max-width: 1000px) {
  .related-news-item {
    margin: 0 0 45px;
    justify-content: center;
    align-items: baseline;

    &__item {
      margin-top: 0;

      &__content {
        h2 {
          font-size: 35px;

          &.related-news-item__item__content--job-title {
            max-width: 210px;
          }
        }

        p {
          max-width: 210px;
          font-size: 17px;
        }

        button {
          font-size: 18px;
          margin-top: 10px;
        }
      }
    }

    &__item {
      h2,
      button {
        font-size: 16px;
        padding: 0 5px;
      }
    }
  }
}
</style>
